import BaseService from '@src/services/BaseService'

class WorkScheduleStatementService extends BaseService {
    constructor() {
        super('dashboards/widgets/work-schedule-statement')
    }

    fetchVuetable(apiUrl, { params } = { params: {} }) {
        const promise = super.fetchVuetable(apiUrl, { params })
        if (apiUrl === 'list') {
            return promise.then((res) => {
                if (res && res.data != null) {
                    res.data = res.data.data ?? res.data
                }
                return res
            })
        }
        return promise
    }

    resume(params) {
        return this.axios.post(`${this.getUrl()}/resume`, params)
    }

    perChain(params) {
        return this.axios.post(`${this.getUrl()}/per-chain`, params)
    }

    perType(params) {
        return this.axios.post(`${this.getUrl()}/per-type`, params)
    }

    statistic(params) {
        return this.axios.post(`${this.getUrl()}/statistic`, params)
    }
}

export default new WorkScheduleStatementService()

